export const stampOptions = [
  {
    text: 'なし',
    value: null,
  },
  {
    text: '未定',
    value: 'undecided',
    color: '#9E9E9E',
    icon: 'material-symbols:help'
  },
  {
    text: '変更',
    value: 'change',
    color: '#F27200',
    icon: 'heroicons-solid:exclamation'
  },
  {
    text: '注意',
    value: 'caution',
    color: '#F27200',
    icon: 'heroicons-solid:exclamation'
  },
  {
    text: '中止',
    value: 'cancel',
    color: '#489FF8',
    icon: 'ion:umbrella-sharp'
  },
  {
    text: '中断',
    value: 'interrupt',
    color: '#489FF8',
    icon: 'fe:bolt'
  },
  {
    text: '連絡',
    value: 'contact',
    color: '#EB539F',
    icon: 'material-symbols-light:mail-sharp'
  },
  {
    text: '確認',
    value: 'confirm',
    color: '#EB539F',
    icon: 'material-symbols:check'
  },
  {
    text: '映像',
    value: 'video',
    color: '#1DB100',
    icon: 'mdi:video'
  },
  {
    text: '結果',
    value: 'result',
    color: '#1DB100',
    icon: 'material-symbols-light:edit-document-rounded'
  }
]

export const stampByValue = stampOptions.reduce((acc, cur) => {
  return {
    ...acc,
    [cur.value]: cur
  }
}, {})